<div class="ne-colors-grid">
  {#each orderedColors as color}
    <slot color={color}></slot>
  {/each}
</div>

<style>
  .ne-colors-grid {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
  }
</style>

<script>
  import { store } from '../stores';
  const orderedColors = [...$store.textColors].sort((a, b) => a.index.state - b.index.state);
</script>
